import Cookies from "js-cookie";
import {
  ENVIORNMENTS,
  getCurrentEnviornment,
  REACT_APP_BaseServerURL,
  REACT_APP_BaseServerURL_SANDBOX,
} from "utils/constants";

const routesWithoutHeader: any = [
  "/get_kinebase_history",
  "/get_video_summary",
];

export async function APIHandlerV2({
  method,
  url,
  data,
  isM2CBackendUrl,
  isSimulationUrl,
  isOldBaseUrl,
}: any) {
  const myAuth = Cookies.get(`${getCurrentEnviornment()}_sessionToken`);
  const userEmail = localStorage.getItem(
    `${getCurrentEnviornment()}_userEmail`,
  );
  // const userEmail = localStorage.getItem("userEmail");
  const combineURL = (url: any) => {
    const baseUrl = getBaseUrl(isM2CBackendUrl, isSimulationUrl);
    return baseUrl + url;
  };

  function getBaseUrl(isM2CBackendUrl: any, isSimulationUrl: any) {
    if (isM2CBackendUrl) {
      return process.env.REACT_APP_M2C_BACKEND_URL;
    }

    if (isSimulationUrl) {
      return process.env.REACT_APP_SimulationBaseServerURL;
    }

    if (isOldBaseUrl) {
      return process.env.REACT_APP_baseURL_old;
    }

    return getCurrentEnviornment() === ENVIORNMENTS.LIVE
      ? REACT_APP_BaseServerURL
      : REACT_APP_BaseServerURL_SANDBOX;
  }

  const raw = JSON.stringify(data);

  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `${myAuth}`);
  myHeaders.append("Email", `${userEmail}`);

  if (routesWithoutHeader.includes(url)) {
    myHeaders.delete("Email");
    myHeaders.delete("Authorization");
  }

  const requestOptions: any = {
    method: method,
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(combineURL(url), requestOptions);
    const result = await response.text();
    const res = JSON.parse(result);

    if (res === "Logged Out") {
      Cookies.remove(`${getCurrentEnviornment()}_sessionToken`);
      localStorage.removeItem(`${getCurrentEnviornment()}_userId`);
      localStorage.removeItem(`${getCurrentEnviornment()}_userEmail`);
      window.location.replace("/");
    }

    return res; // Return the fetched data
  } catch (error) {
    console.error(error);
    throw error; // Rethrow the error for handling in the calling function
  }
}
